import React from "react";
import { getLibelleByIdInIIdLibelle, isNumeric, typeReponseMessageList } from "../../config/helpers";

interface IProps {
  Item?: string;
}

const HtmlRenderTypeReponseMessage: React.FC<IProps> = ({ Item }) => {
  return (
    <span >
      {" "}
      {Item && isNumeric(Item) && getLibelleByIdInIIdLibelle(Number(Item),typeReponseMessageList)}
    </span>
  );
};

export default HtmlRenderTypeReponseMessage;
